import gql from 'graphql-tag';

export const GetContractorServiceZipsByIdQuery = gql`
  query GetContractorServiceZipsByIdQuery($contactId: String) {
    contractorServiceZip(contactId: $contactId) {
      id
      name
      _Ebb_ContactId
      zipCode
    }
  }
`;